export default {
  computed: {
    geofencesQuickFilters() {
      return {
        title: 'Geofences',
        filters: {
          columns: [
            {
              class: 'col-6 col-md-2',
              filters: [
                {
                  name: 'geo-types',
                  label: this.$gettext('Geo Types'),
                  type: 'checkbox-group',
                  options: this.geoTypes.filter(x => x.type === 'polygon').map(x => {
                    return {
                      text: x.name,
                      value: x.id
                    }
                  }),
                  value: [],
                  stacked: true,
                  callback: (val) => {
                    if (val.length > 0) {
                      return [['geo_type_id', 'in', val]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-md-3',
              filters: [
                {
                  name: 'name',
                  label: this.$gettext('Name'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      return [['name', 'ct', val.trim()]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'external-id',
                  label: this.$gettext('External ID'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      return [['external_id', 'ct', val.trim()]]
                    } else {
                      return []
                    }
                  }
                // },
                // {
                //   name: 'reference-location',
                //   label: this.$gettext('Reference Location'),
                //   type: 'text',
                //   value: '',
                //   callback: (val) => {
                //     if (val.length > 0) {
                //       return [[ 'reference_location', 'ct', val.trim() ]]
                //     } else {
                //       return []
                //     }
                //   }
                }
              ]
            },
            {
              class: 'col-md-3',
              filters: [
                {
                  name: 'reference-location',
                  label: this.$gettext('Reference Location'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      return [['reference_location', 'ct', val.trim()]]
                    } else {
                      return []
                    }
                  }
                }
                // {
                //   name: 'with-default-fence',
                //   label: this.$gettext('With Default GeoFence'),
                //   type: 'checkbox',
                //   value: false,
                //   callback: (val) => {
                //     if (val) {
                //       return [[ 'geo_points.geo_type_id', 'eq', 'null', 'true' ]]
                //     } else {
                //       return []
                //     }
                //   }
                // // },
                // // {
                // //   name: 'user-phone',
                // //   label: this.$gettext('Phone'),
                // //   type: 'text',
                // //   value: '',
                // //   callback: (val) => {
                // //     if (val.length > 0) {
                // //       return [[ 'phone', 'ct', val.trim() ]]
                // //     } else {
                // //       return []
                // //     }
                // //   }
                // // },
                // // {
                // //   columns: [
                // //     {
                // //       class: 'col-6',
                // //       filters: [
                // //         {
                // //           name: 'user-enabled',
                // //           label: this.$gettext('User Status'),
                // //           type: 'radio-group',
                // //           options: [
                // //             {
                // //               text: this.$gettext('All'),
                // //               value: null
                // //             },
                // //             {
                // //               text: this.$gettext('Enabled'),
                // //               value: 1
                // //             },
                // //             {
                // //               text: this.$gettext('Disabled'),
                // //               value: false
                // //             }
                // //           ],
                // //           value: null,
                // //           stacked: true,
                // //           callback: (val) => {
                // //             if (val === 1) {
                // //               return [[ 'active', 'eq', 1 ]]
                // //             } else if (val === false) {
                // //               return [[ 'active', 'eq', false ]]
                // //             } else {
                // //               return []
                // //             }
                // //           }
                // //         }
                // //       ]
                // //     },
                // //     {
                // //       class: 'col-6',
                // //       filters: [
                // //         {
                // //           name: 'user-active',
                // //           label: this.$gettext('Online/Offline'),
                // //           type: 'radio-group',
                // //           options: [
                // //             {
                // //               text: this.$gettext('All'),
                // //               value: null
                // //             },
                // //             {
                // //               text: this.$gettext('ONline'),
                // //               value: 1
                // //             },
                // //             {
                // //               text: this.$gettext('OFFline'),
                // //               value: 0
                // //             }
                // //           ],
                // //           value: null,
                // //           stacked: true,
                // //           callback: (val) => {
                // //             if (val === 1) {
                // //               return [['courier_available.active', 'eq', 1]]
                // //             } else if (val === 0) {
                // //               return [['courier_available.active', 'eq', 0]]
                // //             } else {
                // //               return []
                // //             }
                // //           }
                // //         }
                // //       ]
                // //     }
                // //   ]
                // }
              ]
            // },
            // {
              // class: '',
              // filters: [
              //   {
              //     name: 'user-company',
              //     label: ' ',
              //     type: 'company-autocomplete',
              //     value: [],
              //     callback: (val) => {
              //       if (val.length > 0) {
              //         let companies = val.map(function (item) {
              //           return item.id
              //         })
              //         return [[ 'company_id', 'in', companies ]]
              //       } else {
              //         return []
              //       }
              //     }
              //   // },
              //   // {
              //   //   name: 'user-tags',
              //   //   label: null,
              //   //   type: 'tag-autocomplete',
              //   //   value: [],
              //   //   callback: (val) => {
              //   //     if (val.length > 0) {
              //   //       let tags = val.map(function (item) {
              //   //         return item.name
              //   //       })
              //   //       return [[ 'userTags', 'in', tags ]]
              //   //     } else {
              //   //       return []
              //   //     }
              //   //   }
              //   }
              // ]
            }
          ]
        }
      }
    },
    geofencesTrackingHistoryEventsQuickFilters() {
      return {
        title: 'Items Tracking History Events',
        filters: {
          columns: [
            {
              class: 'col-12',
              filters: [
                {
                  name: 'item-shippings-created-at',
                  label: this.$gettext('Event Date Range'),
                  type: 'daterange',
                  opens: 'right',
                  locale: {
                    format: this.$gettext('mm/dd/yyyy')
                  },
                  value: {
                    startDate: this.moment().subtract(6, 'day').toDate(),
                    endDate: this.moment().toDate(),
                    dateRangeActive: true
                  },
                  ranges: {
                    [this.$gettext('Today')]: [this.moment().toDate(), this.moment().toDate()],
                    [this.$gettext('Yesterday and Today')]: [this.moment().subtract(1, 'days').toDate(), this.moment().toDate()],
                    [this.$gettext('Last 7 days')]: [this.moment().subtract(6, 'day').toDate(), this.moment().toDate()],
                    [this.$gettext('Last 30 days')]: [this.moment().subtract(29, 'day').toDate(), this.moment().toDate()]
                  },
                  callback: (val) => {
                    if (val.dateRangeActive) {
                      const range = [
                        this.moment.tz(val.startDate, this.$tz).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
                        this.moment.tz(val.endDate, this.$tz).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
                      ]
                      return [['created_at', 'bt', range]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            }
          ]
        }
      }
    }
  },
  mounted () {
    console.log(this.geoTypes, this.geofencesQuickFilters)
  }
}
